import EmailTableColumn from '@/components/common/email-table-column'
import PhotoTableColumn from '@/components/common/photo-table-column'

export default {
  components: { EmailTableColumn, PhotoTableColumn },
  methods: {
    covertResumeStatus (resume) {
      return `${this.$store.state.global.resume_status_enum.find(x => x.value === resume.jianli_status).label}<br/>${resume.jianli_atime.split(' ').join('<br/>')}`
    },
    jobInfo (job) {
      this.$alert(`${job.zhiwei_jd.replace(/\\n/g, '<br>')}`, {
        customClass: 'job-info',
        title: job.zhiwei_name,
        closeOnPressEscape: true,
        dangerouslyUseHTMLString: true,
        closeOnClickModal: true,
        showConfirmButton: false
      }).catch(() => {})
    }
  }
}
